// src/private/src/api/actions/dashboard/overview.js
import defaultClient from '@src/api/clients/default';

const URL = (path) => {
  return `dashboard/dashboard-overview/${path}/`; // Similar to your daily pulse
};

export function fetchDashboardOverviewByClient(payload = {}) {
  return defaultClient.request({
    url: URL('client'),  // This will hit /api/dashboard/dashboard-overview/client/
    payload,
  });
}

export function fetchDashboardOverviewByChannel(payload = {}) {
  return defaultClient.request({
    url: URL('channel'),  // This will hit /api/dashboard/dashboard-overview/channel/
    payload,
  });
}

export function fetchDashboardOverviewByCampaign(payload = {}) {
  return defaultClient.request({
    url: URL('campaign'),  // This will hit /api/dashboard/dashboard-overview/campaign/
    payload,
  });
}
